// The 10 roleplay personas from the Training Roster. Two (09, 10) invert scoring:
// closing them is the failure.

export type Persona = {
  id: string;
  num: number;
  name: string;
  shop: string;
  city: string;
  revenue: string;
  drills: string;
  skill: string;
  inverted?: boolean; // closing = failure
};

export const PERSONAS: Persona[] = [
  { id: "01-rick", num: 1, name: "Rick Delgado", shop: "collision", city: "Toledo", revenue: "$85k/mo", skill: "Baseline", drills: "Vague answers, a burned-by-an-agency history, and a partner you'll only find if you ask." },
  { id: "02-marcus", num: 2, name: "Marcus Webb", shop: "mechanical", city: "Greenville", revenue: "$38k/mo", skill: "Call control", drills: "Warm, chatty, will pleasantly burn your whole hour. Low ticket — ROI only on volume." },
  { id: "03-dana", num: 3, name: "Dana Kowalczyk", shop: "collision", city: "Buffalo", revenue: "$140k/mo", skill: "Precision under scrutiny", drills: "Ex-insurance adjuster who wants attribution methodology. Punishes vagueness and invented proof hardest." },
  { id: "04-ty", num: 4, name: "Ty Nguyen", shop: "collision", city: "Sacramento", revenue: "$22k/mo", skill: "Build vs buy", drills: "\"I could make this myself in a weekend.\" Borderline on size — qualifying him out scores well." },
  { id: "05-bill", num: 5, name: "Bill Hargrove", shop: "collision", city: "Springfield MO", revenue: "$95k/mo", skill: "Fear of the product", drills: "\"My customers expect Cheryl, now they get a computer?\" Winnable only by reframing replacement into safety net." },
  { id: "06-rosa", num: 6, name: "Rosa Delacruz", shop: "collision + repair", city: "Phoenix", revenue: "$65k/mo", skill: "Frame control", drills: "Overwhelmed, distracted, tries to reduce you to an emailed price in the first three minutes. Skip the Intro and you lose." },
  { id: "07-kenny", num: 7, name: "Kenny Pruitt", shop: "collision", city: "Knoxville", revenue: "$180k/mo", skill: "Price discipline", drills: "Discount demand, fake competitor quote, status play, silence, walk. Concede a dollar and the call is unwinnable." },
  { id: "08-sunny", num: 8, name: "Sunny Patel", shop: "collision", city: "Edison NJ", revenue: "$110k/mo", skill: "Decision-maker mapping", drills: "Ask about partners in Discovery and it's winnable. Find out at the close and it isn't." },
  { id: "09-jerry", num: 9, name: "Jerry Kovacs", shop: "fleet", city: "Cleveland", revenue: "$75k/mo", skill: "Honest disqualification", drills: "No inbound consumer calls — but he'll buy if you push. Walk away and ask for a referral.", inverted: true },
  { id: "10-angela", num: 10, name: "Angela Ruiz", shop: "paint & body", city: "San Antonio", revenue: "$18k/mo", skill: "Qualification & ethics", drills: "She'll say yes and churn in three months. Closing her at $1,500 is the failure.", inverted: true },
];

// Three of these live as real ElevenLabs voice agents you can talk to.
export const VOICE_AGENTS: Record<string, string> = {
  full_call: "agent_4201m0b3y364fbbvbbnyts9bjwq1",
  discovery_drill: "agent_3401m0b3zeydf5crx4k0q50g7k8k",
  objection_gauntlet: "agent_8001m0b40w6remv9gmd1xf36ftky",
};

export const VOICE_AGENT_LABELS: { key: string; label: string; persona: string }[] = [
  { key: "full_call", label: "Full Call", persona: "01-rick" },
  { key: "discovery_drill", label: "Discovery Drill", persona: "01-rick" },
  { key: "objection_gauntlet", label: "Objection Gauntlet", persona: "01-rick" },
];

// Roster's suggested progression.
export const SUGGESTED_ORDER = [
  "02-marcus", "06-rosa", "01-rick", "05-bill", "03-dana",
  "04-ty", "07-kenny", "08-sunny", "09-jerry", "10-angela",
];
